export default __webpack_public_path__ + "media/Sickness.3defcda4.svg";